export const DEFAULT_LIMIT_SEC = 120;
export const DEFAULT_WARNING_SEC = 30;
